<template>
  <div v-if="supportvideo !== null">
    <!-- Video資訊 -->
    <div class="block mb-5">
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="supportvideo.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 分類 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>分類</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            v-model="supportvideo.video_category_id"
            :items="categories"
            placeholder="請選擇所屬分類"
            item-text="title"
            item-value="id"
            outlined
            dense>
          </v-autocomplete>
        </div>
      </div>
      <!-- Order -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>排序[Desc]</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="supportvideo.sort_order"
            outlined
            dense
            type="number"
          ></v-text-field>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="supportvideo.status"></FormSwitch>
        </div>
      </div>
      <!-- banner type = Video -->
      <div class="form-item d-flex py-5">
        <!-- upload type -->
        <div class="w-240px mr-5">
          <h4 class="mb-2">UploadType</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-radio-group v-model="supportvideo.upload_type" row>
            <div
              v-for="uploadType in [
                {
                  label: '自電腦上傳影片',
                  value: 'file',
                },
                {
                  label: '來自Youtube/Youku連結',
                  value: 'link',
                },
              ]"
              :key="uploadType.value"
              class="w-50"
            >
              <v-radio class="mr-01" :value="uploadType.value">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text w-202px">
                    {{ uploadType.label }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
      <!-- banner type = Video, upload type = 自電腦上傳影片 -->
      <div class="form-item d-flex py-5" v-if="supportvideo.upload_type == 'file'">
        <!-- 影片上傳 -->
        <div class="w-240px mr-5">
          <h4 class="mb-2">影片</h4>
          <div class="h5 ink-02-medium--text">
            影片支援格式：.mp4, .mov, .avi <br />
            檔案大小限制：&lt; 10 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FileUploader
            v-model="supportvideo.url"
            dir="supportvideo"></FileUploader>
        </div>
      </div>
      <!-- banner type = Video, upload type = 來自Youtube/Youku連結 -->
      <div class="form-item d-flex py-5" v-if="supportvideo.upload_type == 'link'">
        <!-- Youtube -->
        <div class="w-240px mr-5">
          <h4 class="mb-2">影片連結</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="supportvideo.url"
            prepend-inner-icon="mdi-link"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- img upload -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Preview Image</h4>
          <div class="h5 ink-02-medium--text">
            顯示於列表Overview頁面 <br />
            建議尺寸：430px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="supportvideo.preview_image"
            dir="supportvideo"></ImgUploader>
        </div>
      </div>
      <!-- Summary -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Summary</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-textarea
            v-model="supportvideo.summary"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    FileUploader,
  },
  data: () => ({
    status: true,
    categories: [],
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('supportvideo', ['supportvideo']),
  },
  async created() {
    if (this.supportvideo.video_category_id !== null) {
      this.categories = await this.getVideoCates(this.supportvideo.video_category_id);
    }
  },
  watch: {
    async 'supportvideo.video_category_id'(newValue) {
      if (newValue !== '') {
        this.categories = await this.getVideoCates(newValue);
      } else {
        this.categories = [];
      }
    },
  },
  methods: {
    ...mapActions('supportvideo', ['getVideoCates']),
  },
};
</script>

<style></style>
